import type { LiveState } from '../../lib/agent';
import { LiveMark } from './LiveMark';
import { Wordmark } from './Wordmark';

/**
 * The "○● TWO" lockup (Brand v1.2, M5.2): the LiveMark carrying the agent state next to the
 * wordmark, one left-to-right unit in both UI directions. The mark is never mirrored.
 */
export function Lockup({
  state,
  title,
  size = 'md',
  className = '',
}: {
  state: LiveState;
  /** Accessible name of the mark (the agent state label). */
  title: string;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <span
      dir="ltr"
      className={['inline-flex shrink-0 items-center gap-2', className].join(' ')}
      data-lockup
    >
      <LiveMark state={state} size={16} title={title} />
      <Wordmark size={size} />
    </span>
  );
}
